import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {
    DatePicker,
    DefaultButton,
    IconButton,
    Label,
    NormalPeoplePicker,
    Panel,
    PrimaryButton,
    Stack
} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import {whitespaceMatcher} from "../../Utilities/WhitespaceMatcher.js";
import {dbDate} from "../../Utilities/dbDate";
import ActionField from "../../Components/ActionField";
import AddPerson from "../Person/AddPerson";

function AddTentativeTransaction(props) {
    const [user] = useContext(AuthContext);
    const [until, setUntil] = useState('');
    const [persons, setPersons] = useState([]);
    const [peopleList, setPeopleList] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [addPerson, setAddPerson] = useState(false);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/person", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    const mutated = data.map(item =>
                        {return {id: item.id, text: `${item.name} ${item.surname} (${item.account_manager})`}});
                    setPeopleList(mutated);
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {until: dbDate(until), person: persons.map((item) => item.id)};
        fetch(`/api/transaction/${props.add.id}/tentative`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddTentativeTransaction'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    const filterPersonasByText = (filterText) => {
        return peopleList.filter(item => whitespaceMatcher(filterText, item));
    };

    function getTextFromItem(persona) {
        return persona.text;
    }

    const onFilterChanged = (filterText, currentPersonas, limitResults) => {
        if (filterText) {
            let filteredPersonas = filterPersonasByText(filterText);
            filteredPersonas = limitResults ? filteredPersonas.slice(0, limitResults) : filteredPersonas;
            return filteredPersonas;
        } else {
            return [];
        }
    };
    const onInputChange = (input) => {
        const outlookRegEx = /<.*>/g;
        const emailAddress = outlookRegEx.exec(input);

        if (emailAddress && emailAddress[0]) {
            return emailAddress[0].substring(1, emailAddress[0].length - 1);
        }

        return input;
    }

    useEffect(() => {
        setPersons([]);
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Potencjalną Transakcję"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddTentativeTransaction'>
                <DatePicker
                    label="Termin"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={until}
                    onSelectDate={(e) => setUntil(e || '')}
                />

                <Label required>Kontakty</Label>
                <ActionField
                    field={<NormalPeoplePicker
                        onResolveSuggestions={onFilterChanged}
                        getTextFromItem={getTextFromItem}
                        className={'ms-PeoplePicker'}
                        key={'normal'}
                        selectedItems={persons}
                        onChange={(items) => setPersons(items)}
                        selectionAriaLabel={'Kontakty'}
                        removeButtonAriaLabel={'Usuń'}
                        onInputChange={onInputChange}
                        resolveDelay={300}
                    />}
                    action={<IconButton iconProps={{iconName:'PeopleAdd'}} onClick={() => setAddPerson(true)}/>}
                />
                <AddPerson onSuccess={() => setRefresh(refresh + 1)} add={addPerson} dismissPanel={() => setAddPerson(false)} />
            </form>
        </Panel>
    )
}

export default AddTentativeTransaction;